import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute, NavigationEnd } from '@angular/router';
import { Title } from '@angular/platform-browser';
import { filter, map, switchMap } from 'rxjs/operators';

import { BsLocaleService } from 'ngx-bootstrap/datepicker';
import { defineLocale } from 'ngx-bootstrap/chronos';
import { ptBrLocale } from 'ngx-bootstrap/locale';
import { AuthService } from './seguranca/auth.service';

defineLocale('pt-br', ptBrLocale);

@Component({selector: 'app-root', templateUrl: './app.component.html', styleUrls: ['./app.component.css']})
export class AppComponent implements OnInit {

  constructor(
    public router: Router,
    private activatedRoute: ActivatedRoute,
    private titleService: Title,
    private ngBsLocaleService: BsLocaleService,
    private auth: AuthService) {

        this.router.events.subscribe(event => {
          if (event instanceof NavigationEnd) {
            (<any>window).ga('set', 'page', event.urlAfterRedirects);
            (<any>window).ga('send', 'pageview');
          }
        });
    }

    ngOnInit(): void {

      // define datepicker locale
      this.ngBsLocaleService.use('pt-br');

      // Alterar o title da aplicação dinamicamente através do parâmetro data do arquivo de rotas
      this.router.events
        .pipe(filter(event => event instanceof NavigationEnd))
        .pipe(map(() => this.activatedRoute))
        .pipe(map(route => {
          // tslint:disable-next-line:curly
          while (route.firstChild) route = route.firstChild;
          return route;
        }))
        .pipe(switchMap(route => route.data))
        .subscribe(event => this.titleService.setTitle(event.title));
    }

    exibindoComponentes() {
      return !this.auth.isAccessTokenInvalido();
      // return this.router.url !== '/login';
    }
 }
